import axios from "axios";

// const BASE_URL = process.env.RSVP_API_BASE_URL || window.location.origin.toString + "/api/"
// const BASE_URL = "http://192.168.1.21:8000/api/"
// const BASE_URL = "http://localhost:8000/api/"
const BASE_URL = window.location.origin.toString() + "/api/"

const apiClient = axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

const _get = (url, config = {}) => {
    return apiClient.get(url, config);
};

const _delete = (url, config = {}) => {
    return apiClient.delete(url, config);
};

const _put = (url, data = {}, config = {}) => {
    return apiClient.put(url, data, config);
};

const _patch = (url, data = {}, config = {}) => {
    return apiClient.patch(url, data, config);
};

const _post = (url, data = {}, config = {}) => {
    return apiClient.post(url, data, config);
};


// Export API methods
export { _get, _delete, _put, _post, _patch };